<template>
  <div>
    <v-data-table
        :headers="table.headers"
        :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
        :items="getOffers.data"
        :server-items-length="getOffers.count"
        :disable-sort="true"
        :loading="table.loading"
        :footer-props="{itemsPerPageOptions: table.pageOptions}"
        :page="table.currentPage"
        :items-per-page="table.perPage"
        loading-text="Loading... Please wait"
        fixed-header
        :class="`elevation-1 mt-0 fixed-height co-data-table items-size-${table.heightCounter}`"
        item-class="td_title"
        color="#7F98A5"
        @pagination="updateTablePagination"
        :show-select="true"
        @input="onSelect"
    >
      <template v-slot:top>
        <DataTableTopBar @search="search"></DataTableTopBar>
      </template>
      <template v-for="item of table.headers" :slot="`header.${[item.value]}`" slot-scope="{header}">
        <data-filter type="items"
                     v-if="table.filters.hasOwnProperty(header.value)"
                     :type="['payIn', 'payOut'].includes(header.value) ? 'range' : 'items'"
                     :min="0"
                     :max="1000"
                     :items="table.filters[header.value].data"
                     :entity="header.value"
                     :values="table.filters[header.value].selected"
                     @apply="submitFilter"
                     @search="updateDataInFilters"
        ></data-filter>
        <a v-if="header.sortable === undefined || header.sortable" @click="sortColumn(header.value)">
          <span class="header_title">{{header.text}}</span>
          <v-icon size="16" color="#7F98A5">mdi-arrow-{{header.value === table.orderBy ? table.sortColumnsAsc ? 'up' : 'down' : 'up-down'}}</v-icon>
        </a>
        <span v-else class="header_title">{{header.text}}</span>
      </template>
      <!-- header -->
      <!-- body -->
      <template v-for="header of table.headers" :slot="`item.${[header.value]}`" slot-scope="{item}">
        <template v-if="header.value === 'currency'">
          <v-tooltip top open-delay="400">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">{{item.currency}}</span>
            </template>
            <span>{{item.currencyName}}</span>
          </v-tooltip>
        </template>
        <template v-else-if="isEntityName(header.value)">
          <a class="entity-link" @click="showCard(item)">{{item[header.value]}}</a>
        </template>
        <template v-else>{{item[header.value]}}</template>
      </template>
      <!-- body -->
    </v-data-table>
    <DataTableBottomBar
        :showFilter="Object.values(table.filters).find(f => f.selected.length) !== undefined"
        @clearFilters="removeAllFilters"
        v-model="table.heightCounter"
    ></DataTableBottomBar>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex'
import store from '../../../store'
import {getCookie} from "@/helpers"
import DataTableTopBar from "@/components/common/DataTableTopBar";
import DataTableBottomBar from "@/components/common/DataTableBottomBar";
import offerApi from "@/api/offers";

export default {
  props: {
    predefinedFilters: {
      default: {}
    }
  },
  data() {
    return {
      filtersData: {
        advertiserId: 'getOfferAdvertiserIds',
        name: 'getOfferNames',
        advertiserName: 'getOfferAdvertiserNames',
        statuses: 'getOfferStatuses',
        verticalName: 'getOfferVerticalsNames',
        payIn: 'getOfferPaysIn',
        payOut: 'getOfferPaysOut',
        currencyName: 'getOfferCurrencies',
      },
      table: {
        heightCounter: 45,
        loading: false,
        searchInOffers: '',
        pageChangedByMe: false,
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 100, 200, 500],
        orderBy: '',
        sortColumnsAsc: true,
        selectedOffers: [],
        headers: [
          {text: 'Id', value: 'id'},
          {text: 'Name', value: 'name'},
          {text: 'Status', value: 'status', align:'center'},
          {text: 'Advertiser', value: 'advertiserName'},
          {text: 'Vertical', value: 'verticalName'},
          {text: 'Pay In', value: 'payIn', align:'center'},
          {text: 'Pay Out', value: 'payOut', align:'center'},
          {text: 'Currency', value: 'currencyName', align:'center'},
        ],
        filters: {
          id: {active: false, selected: [], show: false, property: '', data: []},
          name: {active: false, selected: [], show: false, property: '', data: []},
          status: {active: false, selected: [], show: false, property: '', data: []},
          advertiserName: {active: false, selected: [], show: false, property: '', data: []},
          verticalName: {active: false, selected: [], show: false, property: '', data: []},
          payIn: {active: false, selected: [], show: false, property: '', data: []},
          payOut: {active: false, selected: [], show: false, property: '', data: []},
          currencyName: {active: false, selected: [], show: false, property: '', data: []},
        }
      },
    }
  },
  async mounted() {
    await this.getTableData()
    this.getFiltersData()
  },
  components: {
    DataTableTopBar,
    DataTableBottomBar
  },
  methods: {
    ...mapMutations('offers', ['saveMultiplySelectOffers']),
    isEntityName(item) {
      return ['advertiserName'].includes(item)
    },
    showCard(item) {
      store.dispatch('cards/ADD', {
        type: 'advertiser',
        title: item.advertiserName,
        key: `advertiser-${item.id}`,
        data: item
      })
    },
    onSelect(values) {
      this.table.selectedOffers.length = 0
      let formatAff = values.map(i => ({id: i.id, name: i.name}))
      let formatAffTable = values.map(i => (i.id)).join(",");
      this.table.selectedOffers.push(formatAffTable)
      this.saveMultiplySelectOffers(formatAff)
    },
    getFiltersData() {
      const filters = {};
      for(const name in this.table.filters) {
        offerApi.getFilter({
          filter: filters,
          name: name,
        }).then(res => {
          console.log(res);
          this.table.filters[name].data = res;
        });
      }
    },
    async updateDataInFilters(data, modalName) {
      if(modalName) {
        // offers api
        offerApi.getFilter({
          filter: this.table.filters,
          name: modalName,
          searchFilter: data
        }).then(res => {
          this.table.filters[modalName].data = res;
        });
      }
    },
    async sortColumn(column) {
      this.table.sortColumnsAsc = (this.table.orderBy === column) ? !this.table.sortColumnsAsc : true;
      this.table.orderBy = column
      await this.getTableData()
    },
    updateFiltersFromQuery() {
      let filtersMap = {
        id: 'ids',
        name: 'names',
        advertiserId: 'advertiserIds',
        advertiserName: 'advertiserNames',
        verticalName: 'verticalNames',
        payIn: 'paysIn',
        payOut: 'paysOut',
        status: 'statuses',
        currencyId: 'currencies'
      }
      const queryFilters = JSON.parse(this.$route.query.filters);
      for (const name in this.table.selectedFilters) {
        if (queryFilters[filtersMap[name]]) {
          this.table.selectedFilters[name] = queryFilters[filtersMap[name]];
        }
      }
    },
    updateTablePagination(params) {
      if (
          (this.table.currentPage === params.page &&
              this.table.perPage === params.itemsPerPage) ||
          this.table.pageChangedByMe
      ) {
        this.table.pageChangedByMe = false;
        return
      }
      this.table.currentPage = params.page
      this.table.perPage = params.itemsPerPage
      if (this.$route.query.filters) {
        this.updateFiltersFromQuery();
      }
      this.getTableData();
    },
    async submitFilter(data, entity) {
      this.table.currentPage = 1;
      this.table.pageChangedByMe = true;
      if(data && entity) {
        this.table.filters[entity].selected = data;
      }
      return await this.getTableData()
    },
    async getTableData(filters) {
      this.table.loading = true
      filters = this.getFilters();
      if (this.table.searchInOffers.length > 0) {
        filters['search'] = this.table.searchInOffers
      }
      if (Object.keys(this.predefinedFilters).length && !filters.status) {
        if (this.predefinedFilters.status) {
          filters.status = this.predefinedFilters.status.join("','");
        }
      }
      await store.dispatch('offers/saveOffersStore', {
        byColumn: this.table.orderBy.split(/(?=[A-Z])/).join('_').toLowerCase(),
        ascending: this.table.sortColumnsAsc,
        page: this.table.currentPage,
        limit: this.table.perPage,
        filters: filters || null,
        token: getCookie('accessToken')
      })

      this.table.loading = false
    },
    getFilters() {
      const filters = {};
      filters['search'] = (this.table.searchInOffers.length > 0) ? this.table.searchInOffers : '';
      for(const name in this.table.filters) {
        filters[name] = (this.table.filters[name].selected.length > 0) ?
            `${this.table.filters[name].selected.join('\',\'')}` :
            null;
      }

      return filters;
    },
    async removeAllFilters() {
      for (let key in this.table.filters) {
        this.table.filters[key].selected = [];
      }
      await this.getTableData()
    },
    activateFilters() {
      Object.keys(this.table.selectedFilters).forEach(value => {
        this.table.activeFilters[value] = (this.table.selectedFilters[value].length > 0)
      })
    },
    addParamsToLocation(params) {
      const query = JSON.stringify(params) === '{}' ? this.$route.path :
          this.$route.path + '?' + Object.keys(params).map(
          key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
          ).join('&')
      history.pushState({}, null, query);
    },
    ...mapActions('alert', ['ALERT_SUCCESS', 'ALERT_ERROR', 'ALERT_INFO', 'ALERT_WARNING', 'ALERT']),
    search(value) {
      this.table.searchInOffers = value
      this.submitFilter();
    },
  },
  watch: {
    'table.selectedOffers'() {
      if(this.table.selectedOffers[0].length >= 1) {
        return this.$emit('activeButton', true)

      } else {
        this.$emit('activeButton', false)
      }
    }
  },
  computed: {
    ...mapGetters('offers', [
      'getOffers',
      'getOfferAdvertiserIds',
      'getOfferAdvertiserNames',
      'getOfferVerticalsNames',
      'getOfferStatuses',
      'getMultiplySelectOffers',
      'getOfferNames',
      'getOfferPaysIn',
      'getOfferPaysOut',
      'getOfferCurrencies'
    ]),
    ...mapGetters('advertisers', ['getMultiplySelectAdvertisers']),
  }
}
</script>

<style scoped lang="sass">
  .search_btn_wrap
    .search_wrapper
      padding-bottom: 0
      .v-text-field
        padding-top: 0
        margin-top: 0

</style>
